import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	searchJiraAdmin: {
		id: 'directory-base-v3.header.search-jira-admin',
		defaultMessage: 'Search Jira admin',
		description: 'Label for the action selector for Jira admin',
	},
});
